import React from "react";
import { Link } from "react-router-dom";

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-[#0f0f0f] text-white flex flex-col">

      {/* NAV */}
      <div className="flex justify-between items-center px-6 py-4 border-b border-white/10">
        <Link to="/">
          <img
            src="https://cdn.prod.website-files.com/638fda8f8e2f041af84cb5a7/6824d581ae24f69d45e26536_beem%20logo%203.png"
            alt="Beem Logo"
            className="w-28"
            style={{ cursor: "pointer" }}
          />
        </Link>
      </div>

      {/* CONTENT */}
      <div className="flex justify-center px-6 py-12">
        <div className="max-w-3xl w-full">

          <h1 className="text-4xl font-bold mb-4">Terms of Service</h1>
          <p className="text-gray-400 mb-8">
            Effective date: 09/06/2026
          </p>

          <div className="space-y-8 text-gray-300 text-sm leading-relaxed">

            {/* INTRO */}
            <section>
              <p>
                These Terms of Service ("Terms") govern your access to and use of the Beem platform,
                website, applications, and related services ("Services") operated by Beem Tech Limited
                ("Beem", "we", "us", or "our"). By creating an account or using the Services, you agree
                to these Terms.
              </p>
            </section>

            {/* ABOUT */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">1. About Beem</h2>
              <p>
                Beem is a property management software platform that allows landlords, tenants, and
                property agents to manage properties, documents, communications, and payments in one place.
              </p>
              <p className="mt-2">
                Beem Tech Limited is a software provider and is not a legal advisor, estate agent,
                letting agent, or financial institution.
              </p>
            </section>

            {/* ELIGIBILITY */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">2. Eligibility</h2>
              <p>
                You must be at least 18 years old and capable of entering into legally binding agreements
                to use the Services.
              </p>
              <p className="mt-2">
                By using Beem, you confirm that all information you provide is accurate and up to date.
              </p>
            </section>

            {/* ACCOUNTS */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">3. User Accounts</h2>
              <p>
                You are responsible for maintaining the confidentiality of your account credentials and
                for all activity that occurs under your account.
              </p>
              <p className="mt-2">
                You must notify us immediately if you suspect any unauthorised access to your account.
              </p>
            </section>

            {/* PLATFORM USAGE */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">4. Use of the Platform</h2>
              <p>
                You agree to use Beem only for lawful purposes and in accordance with these Terms.
              </p>
              <p className="mt-2">
                You must not misuse the platform, interfere with its operation, or attempt to gain
                unauthorised access to systems or data.
              </p>
            </section>

            {/* SUBSCRIPTIONS */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">5. Subscriptions & Billing</h2>
              <p>
                Beem offers both free and paid subscription plans. Paid plans may include additional
                features and functionality.
              </p>
              <p className="mt-2">
                Payments are processed via Stripe and may renew automatically unless cancelled.
              </p>
            </section>

            {/* USER CONTENT */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">6. User Content</h2>
              <p>
                You retain ownership of any content you upload, including documents, messages, and
                property data.
              </p>
              <p className="mt-2">
                By uploading content, you grant Beem a licence to host, store, and process it solely
                for the purpose of providing the Services.
              </p>
            </section>

            {/* DATA DISCLAIMER */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">7. Data & Responsibilities</h2>
              <p>
                You are responsible for ensuring that any data, documents, or information you upload
                comply with applicable laws and regulations.
              </p>
              <p className="mt-2">
                Beem does not verify or guarantee the accuracy, legality, or enforceability of user
                submitted content or documents.
              </p>
            </section>

            {/* THIRD PARTY */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">8. Third-Party Services</h2>
              <p>
                The Services may integrate with third-party providers such as Stripe or cloud hosting
                services.
              </p>
              <p className="mt-2">
                We are not responsible for the actions, policies, or failures of third-party services.
              </p>
            </section>

            {/* LIABILITY */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">9. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, Beem is provided on an "as is" and "as available"
                basis.
              </p>
              <p className="mt-2">
                We are not liable for indirect, incidental, or consequential damages, including disputes
                between landlords, tenants, or agents.
              </p>
              <p className="mt-2">
                Our total liability shall not exceed the amount paid by you in the last 12 months.
              </p>
            </section>

            {/* TERMINATION */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">10. Termination</h2>
              <p>
                We may suspend or terminate your access if you breach these Terms or misuse the platform.
              </p>
              <p className="mt-2">
                You may stop using the Services at any time.
              </p>
            </section>

            {/* CHANGES */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">11. Changes to Terms</h2>
              <p>
                We may update these Terms from time to time. Continued use of the Services after changes
                means you accept the updated Terms.
              </p>
            </section>

            {/* LAW */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">12. Governing Law</h2>
              <p>
                These Terms are governed by the laws of England and Wales.
              </p>
            </section>

            {/* CONTACT */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">13. Contact</h2>
              <p>
                If you have any questions, contact us at:
                <br />
                📧 wjelson@beemtech.co.uk
              </p>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
}
